import React, { useEffect, useState } from "react";
import { arrendatarioService } from "../../services/api";
import { useNomes } from "./hooks/useNomes";
import { useNomeForm } from "./hooks/useNomeForm";
import NomeForm from "./components/NomeForm";
import NomesTable from "./components/NomesTable";
import BatchDeleteModal from "./components/BatchDeleteModal";
import FilterBar from "./components/FilterBar";

/**
 * Componente principal de Nomes refatorado
 */
const Nomes = () => {
  // Hooks personalizados para gerenciar a lógica de negócio
  const {
    nomes,
    loading,
    loadingMore,
    error,
    statusOptions,
    selectedStatus,
    nameFilter,
    selectedItems,
    confirmBatchDelete,
    batchDeleteProgress,
    handleStatusChange,
    handleNameFilterChange,
    excluirNome,
    handleSelectItem,
    handleSelectAll,
    iniciarExclusaoEmLote,
    cancelarExclusaoEmLote,
    confirmarExclusaoEmLote,
    fetchNomes,
    loadMore,
    hasMore,
    total
  } = useNomes();

  // Hook para gerenciar o formulário de cadastro
  const nomeForm = useNomeForm(fetchNomes);

  // Franquia 0 = distribuição não contratada: os nomes não são ativados no provedor
  const [semFranquia, setSemFranquia] = useState(false);
  useEffect(() => {
    let ativo = true;
    arrendatarioService.buscarArrendatario()
      .then((arrendatario) => {
        if (ativo) setSemFranquia(arrendatario?.franquia === 0);
      })
      .catch(() => {
        if (ativo) setSemFranquia(false);
      });
    return () => { ativo = false; };
  }, []);

  if (loading && nomes.length === 0) {
    return (
      <div className="flex items-center justify-center h-64 text-muted-foreground text-sm">
        Carregando dados...
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-red-50 border border-red-200 text-red-700 rounded-lg p-4 text-sm">
        Erro ao carregar dados: {error}
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-semibold text-foreground">Nomes Cadastrados</h1>
          <p className="text-sm text-muted-foreground mt-1">Termos de pesquisa para monitoramento</p>
        </div>
        <button
          className="px-4 py-2 text-sm font-medium rounded-md bg-primary text-primary-foreground hover:bg-primary/90 transition-colors"
          onClick={nomeForm.openModal}
        >
          + Adicionar Novo Nome
        </button>
      </div>
      
      {/* Modal de formulário para adicionar novo nome */}
      <NomeForm 
        showAddModal={nomeForm.showAddModal}
        addLoading={nomeForm.addLoading}
        novoNome={nomeForm.novoNome}
        poloOptions={nomeForm.poloOptions}
        statusOptionsCadastro={nomeForm.statusOptionsCadastro}
        abrangencias={nomeForm.abrangencias}
        tipoConsultaOptions={nomeForm.tipoConsultaOptions}
        mostrarCampoNome={nomeForm.mostrarCampoNome}
        mostrarCampoCpfCnpj={nomeForm.mostrarCampoCpfCnpj}
        mostrarCampoOab={nomeForm.mostrarCampoOab}
        mostrarCampoDocumentos={nomeForm.mostrarCampoDocumentos}
        handleNovoNomeChange={nomeForm.handleNovoNomeChange}
        handleAbrangenciaChange={nomeForm.handleAbrangenciaChange}
        handleAddNome={nomeForm.handleAddNome}
        closeModal={nomeForm.closeModal}
      />
      
      {/* Barra de filtros e ações */}
      <FilterBar 
        statusOptions={statusOptions}
        selectedStatus={selectedStatus}
        nameFilter={nameFilter}
        onNameFilterChange={handleNameFilterChange}
        selectedItemsCount={selectedItems.length}
        onStatusChange={handleStatusChange}
        onBatchDelete={iniciarExclusaoEmLote}
      />
      
      {/* Modal de confirmação para exclusão em lote */}
      <BatchDeleteModal 
        confirmBatchDelete={confirmBatchDelete}
        batchDeleteProgress={batchDeleteProgress}
        selectedItemsCount={selectedItems.length}
        onConfirm={confirmarExclusaoEmLote}
        onCancel={cancelarExclusaoEmLote}
      />
      
      {semFranquia && (
        <div className="bg-red-50 border border-red-200 text-red-700 rounded-lg p-4 text-sm mb-4">
          Franquia de distribuição não contratada. Os nomes cadastrados não serão ativados até a
          contratação. Entre em contato com seu consultor.
        </div>
      )}

      {/* Tabela de nomes */}
      <NomesTable 
        nomes={nomes}
        selectedItems={selectedItems}
        handleSelectItem={handleSelectItem}
        handleSelectAll={handleSelectAll}
        onDelete={excluirNome}
        hasMore={hasMore}
        loadingMore={loadingMore}
        onLoadMore={loadMore}
        total={total}
        semFranquia={semFranquia}
      />
    </div>
  );
};

export default Nomes;
